import React from 'react';
import { Collapse } from 'reactstrap';
import propTypes from 'prop-types';

import SearchForm from './filterPanel/SearchForm';
import FilterForm from './filterPanel/FilterForm';
import SortForm from './filterPanel/SortForm';
import { FilterPanelInner, Divider } from '../styled';

const FilterPanel = props => (
  <Collapse isOpen={props.isOpen}>
    <FilterPanelInner id={props.id}>
      <SearchForm
        keyword={props.keyword}
        isLoading={props.isLoading}
        onInputChange={props.onDraftChange}
        onSubmit={props.onSubmitPanel}
      />
      <FilterForm
        status={props.status}
        source={props.source}
        isLoading={props.isLoading}
        onInputChange={props.onDraftChange}
        onSubmit={props.onSubmitPanel}
      />
      <Divider />
      <SortForm
        per_page={props.per_page}
        sort={props.sort}
        isLoading={props.isLoading}
        onInputChange={props.onSortChange}
      />
    </FilterPanelInner>
  </Collapse>
)

export default FilterPanel;

FilterPanel.propTypes = {
  id: propTypes.string,
  isOpen: propTypes.bool.isRequired,
  isLoading: propTypes.bool,
  keyword: propTypes.string,
  status: propTypes.string,
  source: propTypes.string,
  per_page: propTypes.oneOfType([propTypes.number, propTypes.string]),
  sort: propTypes.string,
  onDraftChange: propTypes.func.isRequired,
  onSortChange: propTypes.func.isRequired,
  onSubmitPanel: propTypes.func.isRequired
}

FilterPanel.defaultProps = {
  isLoading: false,
  keyword: '',
  status: '',
  source: ''
}
